export const STORE_SETTINGS_API_URL = 'ui/partner/store_settings';
export const TAX_GROUPS_API_URL = `${STORE_SETTINGS_API_URL}/tax_groups`;

export const storeSettingsQueryKeys = {
  all: [STORE_SETTINGS_API_URL],
  taxGroups: {
    all: [TAX_GROUPS_API_URL],
  },
};
